"use client";
import React, { useEffect, useState } from 'react';
// import { SampleData } from '../../asset/data';
// import { DataCheese } from './TableProduct';
import axios from 'axios';
import { Cheese3 } from '../../asset/cheeseIcons/cheese3';
import { cn } from '@postcheesy/core-utils';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@postcheesy/ui-lib/molecules';
import { Info, InfoIcon } from 'lucide-react';
import apiClient from '../../api/apiClient';
import { Button } from '@postcheesy/ui-lib/atoms';

export const ProgressBar: React.FC = () => {
    const [totalDoses, setTotalDoses] = useState<number>(0);
    const [infoOpen, setInfoOpen] = useState(false);

    useEffect(() => {
        const fetchDoses = async () => {
            try {
                const response = await apiClient.get(`/doses`);
                setTotalDoses(response.data);
            } catch (error) {
                // console.error('Error fetching doses:', error);
            }
        };

        fetchDoses();
    }, []);

    const progress = Math.min(100, ((totalDoses % 10000) / 10000) * 100);

    const previousLevel = Math.floor(totalDoses / 10000) * 10000;
    const nextLevel = totalDoses % 10000 === 0 ? previousLevel + 10000 : Math.ceil(totalDoses / 10000) * 10000;

    return (
        <div className='flex flex-col items-center w-full gap-4'>
            <div className='flex items-center justify-center gap-4'>
                <Cheese3 className="h-8 w-8" />
                <div className='flex items-center gap-2'>
                    <h2 className="text-2xl font-semibold text-foreground serif">Doses Gourmandes</h2>
                    <InfoIcon className="h-4 w-4 md:hidden" onClick={() => setInfoOpen(!infoOpen)} />
                </div>

                <div className='hidden md:block'>
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger onClick={() => setInfoOpen(!infoOpen)}>
                                <InfoIcon className="h-4 w-4" />
                            </TooltipTrigger>
                            <TooltipContent>
                                Accumulez des doses gourmandes tout au long de l'année et recevez des récompenses savoureuses !
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                </div>
            </div>
            {infoOpen &&

                <div className='md:hidden text-foreground text-sm'>Accumulez des doses gourmandes tout au long de l'année et recevez des récompenses savoureuses !</div>
            }
            <div className="relative h-8 w-full rounded-full bg-primary-foreground">
                <div className={cn(`bg-primary h-full rounded-full flex justify-end ${progress}%`)} style={{ width: `${progress}%`, minWidth: '5%' }}>
                    <div className='flex justify-center items-center w-full text-primary-foreground'>
                        <div className='text-lg font-semibold'>{totalDoses}</div>
                    </div>
                </div>
            </div>
            <div className='flex justify-end w-full text-foreground'>
                <div>Prochaine récompense à {nextLevel} doses</div>
            </div>
        </div>
    )
}